
import { defineComponent } from "vue";
import tokensImportAssetComponent from "@/modules/tokens/components/tokensImportAssetComponent.vue";
import tokensCreateAssetFormComponent from "@/modules/tokens/components/tokensCreateAssetFormComponent.vue";
import store from '@/store/index';
import { fetchedAsset } from '@/_models/Token';
import { Helper } from "@/utils/Helper";
import { AccountHttp, Address, Mosaic } from "tsjs-xpx-chain-sdk";


// import image from "../../../assets/user.png";
export default defineComponent({
  name: 'viewTokensCreate',
  components: {
    tokensImportAssetComponent,
    tokensCreateAssetFormComponent,
  },
  data: function () {
    return {
      userData: store.getters['auth/user'] ?? "",
      publicKey: '',
      isInsufficientBalance: false,
      isInvalidPublicKey: false,
      selectedComponent: 'create',
    };
  },
  computed:{
    testnetLabel() {
      return store.getters['config/configTestnetLabel'];
    },
    mainnetLabel() {
      return store.getters['config/configMainnetLabel'];
    },
    network() {
      return Helper.capitalizeFirstLetter(this.$route.params.network);
    }
  },
  mounted(){
    if(this.$route.params.network == 'mainnet' && !this.userData.mainnetWalletAddress){
      this.$router.push ({ name: 'viewTokensCreate', params: { network: 'testnet' } })
    }
    if(this.$route.params.network != 'mainnet' && this.$route.params.network != 'testnet'){
      this.$router.push ({ name: 'viewTokensList' })
    }
    this.initAssetId();
  },
  methods: {
    async initAssetId() {
      let accountHttp = new AccountHttp(this.network=='Testnet'?store.getters['config/getTestnetApi']:store.getters['config/getMainnetApi']);
      this.publicKey = this.network=='Testnet'?this.userData.testnetPublicAddress:this.userData.mainnetPublicAddress;
      if(!this.publicKey){
        this.isInvalidPublicKey = true;
      }
      // get account balance
      if(!this.isInvalidPublicKey){
        const address = Address.createFromRawAddress(this.network=='Testnet'?this.userData.testnetWalletAddress:this.userData.mainnetWalletAddress);
        let account = await accountHttp.getAccountInfo(address).toPromise();
        if(account.mosaics.length > 0){
          let assets:fetchedAsset[] = account.mosaics.map((asset:Mosaic) => {
            return {
              id: asset.id.toHex(),
              balance: asset.amount.compact(),
            }
          });
          console.log(assets);
          let xpxAsset = assets.find(asset => asset.id.toLocaleUpperCase() == (this.network=='Testnet'?store.getters['config/getTestnetXPXAssetId']:store.getters['config/getMainnetXPXAssetId']));
          if(xpxAsset.balance / Math.pow(10, 6) > 1500){
            // enough balance to create asset
            this.isInsufficientBalance = false;
          }else{
            // display insufficient balance and disable create token button
            this.isInsufficientBalance = true;
          }
        }
      }
    },
  },

  setup(){
    return {
      Helper,
    }
  }
});
